import { Client } from '@microsoft/microsoft-graph-client'
// eslint-disable-next-line import/no-unresolved
import { User } from '@microsoft/microsoft-graph-types'
import {
  GRAPHSERVICE_URL_MYPHOTO,
  GRAPHSERVICE_URL_USERS,
} from './graphurl-constants'

/**
 * This Method Takes the access token and returns the authenticated client object.
 * This authenticated client used to make api calls to microsoft graph api
 * @param accessToken
 * @returns
 */
const getAuthenticatedClient = (accessToken: string) => {
  return Client.init({
    authProvider: (done) => {
      done(null, accessToken)
    },
  })
}

/**
 * This method returns the user information by making graph api call
 * @param userId
 * @param accessToken
 * @returns
 */
export const getUserDetails = async (
  userId: string,
  accessToken: string
): Promise<User> => {
  const client = getAuthenticatedClient(accessToken)
  console.log('Making Graph API call for userId:', userId)

  const result = await client
    .api('/' + userId)
    .select(
      'id,displayName,mail,userPrincipalName,jobTitle,officeLocation,givenName,surname'
    )
    .get()

  console.log('Graph API response for', userId, ':', {
    id: result.id,
    displayName: result.displayName,
    userPrincipalName: result.userPrincipalName,
    mail: result.mail,
  })

  return result
}

export const getMyPhoto = async (accessToken: string): Promise<string> => {
  return getUserPhoto('me', accessToken)
    .then((response) => {
      if (response.ok) {
        return response.blob()
      }
    })
    .then((photoBlob) => {
      if (photoBlob) {
        return URL.createObjectURL(photoBlob)
      } else {
        return ''
      }
    })
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getUserPhoto = async (userId: string, accessToken: string) => {
  return fetch(GRAPHSERVICE_URL_MYPHOTO, {
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + accessToken,
      'Content-Type': 'application/json',
    },
  })
}
export const getUserInitials = (givenName: string, surName: string): string => {
  return givenName.trim()[0] + surName.trim()[0]
}

export const getAllPeopleDetailsByName = async (
  name: string,
  accessToken: string
) => {
  const url = `${GRAPHSERVICE_URL_USERS}?$search="displayName:${name}"&givenName ne null&$top=50&$select=id,displayName,mail,userPrincipalName,jobTitle,officeLocation`
  console.log('Search API URL:', url)

  const headers = {
    Authorization: 'Bearer ' + accessToken,
    'Content-Type': 'application/json',
    ConsistencyLevel: 'eventual',
  }
  const request = {
    method: 'GET',
    headers,
  }
  const filteredUsers = fetch(url, request)
    .then((response) => {
      if (response.ok) return response.json()
    })
    .then((data) => {
      console.log('Search API response for', name, ':', data)
      if (data) return data.value
      else return 'Failed to fetch people details by name'
    })

  return filteredUsers
}
